import { Page } from "@/App/Page";
import { useAuthentication } from "@/Slices/authenticationSlice";
import type { ReactElement, ReactNode } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routeMatches } from "@/Routing/routeMatches";

interface NotAuthedRouteProps {
  exact?: boolean | undefined;
  children: ReactNode;
  path: string;
  noMatchRedirect?: string | undefined;
}
function NotAuthedRoute(props: NotAuthedRouteProps): ReactElement {
  const { isAuthenticated } = useAuthentication();
  const navigate = useNavigate();

  const location = useLocation();

  const match = routeMatches(location.pathname, props.path, props.exact);

  useEffect(function () {
    if (isAuthenticated && match) {
      navigate(props.noMatchRedirect || "/");
    }
  }, []);

  if (!isAuthenticated) {
    return (
      <Page exact={props.exact} path={props.path}>
        {() => props.children}
      </Page>
    );
  }

  return <></>;
}
export default NotAuthedRoute;
